import React from 'react';
import { withRouter } from 'react-router';
import { Switch, Route } from 'react-router-dom';

import TrainingSettingsNav from '../navigation/TrainingSettingsNav';

import Settings from '../../pages/training/settings/Settings';
import SettingsUnits from '../../pages/training/settings/SettingsUnits';

const TrainingSettingsRouter = ({ match, location }) => {
  return (
    <TrainingSettingsNavTemplate>
      <Switch>
        <Route exact path = {match.path + ''} >
          <Settings />
        </Route>
        <Route path = {match.path + '/units'} >
          <SettingsUnits />
        </Route>
      </Switch>
    </TrainingSettingsNavTemplate>
  );
}

const TrainingSettingsNavTemplate = (props) => {
  return (
    <>
      <TrainingSettingsNav />
      {props.children}
    </>
  );
}

export default withRouter(TrainingSettingsRouter);